var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUsersActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#52C9F4;}\n\t.st1{fill:none;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 10,
    cy: 11.2,
    rx: 3.5,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,22c0-3-3.1-5.5-7-5.5c-2.4,0-4.5,1-5.8,2.4L3,22"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 11,
    cy: 11.8,
    rx: 4,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,24c0-3.6-3.6-6.5-8-6.5S3,20.4,3,24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0h32v32H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsersActive);
export default __webpack_public_path__ + "static/media/ic_users_active.a84c6c3c84d4685a530ef5ba023ae84f.svg";
export { ForwardRef as ReactComponent };